import CryptoJs from 'crypto-js'

// 设置cookie(name, value, 失效时间)
const setCookie = (name, value, hour) => {
    let date = new Date();
    date.setTime(date.getTime() + (hour * 60 * 60 * 1000));
    let expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires;
}

export const clearCookie = (name) => {
  setCookie(name, "", -1);
}

export const getUrlKey = (name) => {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

// 注册路径
export const registerPath = () => {
  return '/enroll';
}

// 登录路径
export const loginPath = () => {
  return '/log-in';
}

// 返回字典中value对应的label值
const getLabel = (list, value, valueName = 'value', labelName = 'label') => {
    let result = list.filter(val => {
        return val[valueName] === value;
    })[0];
    return result ? result[labelName] : '';
}

// 将数组转换成指定属性的对象
const changeArrToMap = (arr, label) => {
    let mapTemp = {}
    arr.forEach(val => {
        mapTemp[val[label]] = val
    })
    return mapTemp
}

/**
 * 时间格式化
 * @param timeStamp 时间戳（秒）
 * @param fmt 日期格式
 * @return str 返回fmt格式
 */
const formatDate = (timeStamp, fmt) => {
    if (timeStamp.toString().length === 10) {
        timeStamp = timeStamp * 1000
    }
    let date = new Date(timeStamp)
    let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return fmt
}
// 格式化时间耗时 xx小时xx分  timer 单位毫秒
const formatTimer = (timer) => {
    timer = Math.floor(timer / 1000) // 转为秒
    let dd = Math.floor(timer / 60 / 60 / 24)
    let hh = Math.floor(timer / 60 / 60)
    let mm = Math.floor(timer / 60)
    let str = ''
    if (dd) {
        str += dd + '天'
    }
    if (hh) {
        str += (hh - dd * 24) + '小时'
    }
    if (mm) {
        str += (mm - hh * 60) + '分钟'
    }
    str += (timer - mm * 60) + '秒'
    return str || 0
}

// 金额元转分
const moneyToFen = (money) => {
    if (!money) {
        return money
    }
    return Math.round(money * 10000 / 100)
}
// 金额分转元(默认保留两位小数)
const moneyToYuan = (money, float = 2) => {
    if (!money) {
        return money
    }
    return Number((money / 100).toFixed(float))
}
// json解析方法 若解析不了不会报错 返回temp 若不指定则返回string本身
const commonJsonParse = (string, temp) => {
    try {
        return JSON.parse(string) || temp // JSON.parse(null) == null
    } catch (e) {
        return temp || string
    }
}

//生成随机字符串 width为生成位数
const getNonceStr = (width = 6) => {
    let str = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789';
    let maxPos = str.length;
    let code = '';
    for (let i = 0; i < width; i++) {
        code += str.charAt(Math.floor(Math.random() * maxPos));
    }
    return code;
}

//当前时间生成时间戳,默认生成10位时间戳,可选13位
const getCurTimeStamp = (width = 10) => {
    if (width === 13) {
        return new Date().getTime();
    }
    var timestamp = Date.parse(new Date()).toString();
    return timestamp.substr(0, timestamp.length - 3);
}

//获取md5签名
const getMd5Sign = (data, app_secret) => {
    var sign = getParam(data, app_secret)
    return CryptoJs.MD5(sign).toString()
}

//获取签名原串
const getParam = (data, app_secret) => {
    let keys = Object.keys(data).sort()
    console.log("升序后的数据"+ keys)
    //拼接待签名字符串
    let str = []
    for (var p = 0; p < keys.length; p++) {
        if (keys[p] === "signature") { // "==" ==宽松相等，隐性类型转换，值相等，返回true; "===" 严格相等，值和类型都相等，返回true
            continue;
        }
        let dataStr = data[keys[p]];
        if (typeof dataStr == 'object' && dataStr) {
            dataStr = JSON.stringify(dataStr)
        }
        str.push(keys[p] + "=" + dataStr);
    }
    let sign = str.join("&")
    console.log("签名原串：" + sign)
    return sign + app_secret;
}

//判断是否是json
const isJson = (str) => {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }
    if (typeof str == 'object' && str) {
        return true;
    }
}


export {
    setCookie,
    getLabel,
    formatDate,
    formatTimer,
    changeArrToMap,
    moneyToFen,
    moneyToYuan,
    commonJsonParse,
    getNonceStr,
    getCurTimeStamp,
    getParam,
    getMd5Sign,
    isJson
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js